import axios from 'axios'

export default {
    async getBase64(url) {
        return axios
            .get(url, {
                responseType: 'arraybuffer',
                Authorization: 'Bearer ' + localStorage.getItem('token')
            })
            .then(response => {
                let image = btoa(
                    new Uint8Array(response.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ''
                    )
                )
                return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
            })
    }
}
